'use client';

import { OutOfStockButton } from '@coolblue-development/next-patterns/client';
import { AddToCartButton as AddToCartButtonComponent } from '@coolblue-development/next-shopping-cart/client';
import { WishlistProduct } from '@coolblue-development/next-wishlist';
import { FilterPageProduct } from '@features/filter/types';
import { AvailabilityState, Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';
import { addProductToShoppingCart } from '@utils/nextShoppingCartActions/addProductToShoppingCart';
import { useRouter } from 'next/navigation';
import { type FormEvent, useState } from 'react';

type Props = {
  product: Product | FilterPageProduct | WishlistProduct;
  onClick?: () => void;
};

function AddToCartButton({ product, onClick }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const { t } = useTranslation('webshop.addToCartButton');

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setIsLoading(true);

    onClick?.();

    addProductToShoppingCart({
      productId: Number(product.id),
      revalidate: typeof window === 'undefined'
    })
      .then(response => {
        const redirectUrl = response?.data?.redirectUrl;

        if (redirectUrl && typeof window !== 'undefined') {
          router.push(redirectUrl);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }

  const inStock = [AvailabilityState.OnStock, AvailabilityState.PreOrder].includes(
    product.availabilityState
  );

  return (
    <form onSubmit={handleSubmit}>
      {inStock ? (
        <AddToCartButtonComponent loading={isLoading} ariaLabel={t('label')} />
      ) : (
        <OutOfStockButton
          variant='compact'
          ariaLabel={t('activeMailer.subscribeButtonLabel')}
          href={product?.urls?.product ?? ''}
        />
      )}
    </form>
  );
}

export default AddToCartButton;
